import { LuHeart } from "react-icons/lu";

const data = [
  {
    release: "March 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/friends.png",
    title: "FRI(END)S",
    artist: "V",
    songType: "single",
    url: "https://open.spotify.com/track/0PBTlQ84CBJF0tBnKGmQa6?si=df18be30810b486b",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "Wish You Hell",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/7b8SkcdeiTuo6FQXdPgPWW?si=fc5a774700e243d8",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "His Car Isn't Yours",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/5cvwFPDokfdI6T7O0HgzuM",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "Best Ever",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/3kiQOTlExsRTAQW0P0jcTH",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "Better Judgement",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/0CjGCpqs4qBqZi7ibYyZLi",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "Queen Of The Party",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/7owXmiwfpFAZW24qNPyYfr",
  },
  {
    release: "March 12, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/wish-you-hell.png",
    title: "Vermilion",
    artist: "WENDY",
    songType: "ep",
    url: "https://open.spotify.com/track/3Oo9zqlxcXNEaINhiXOrBm",
  },
  {
    release: "February 26, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/one-spark.png",
    title: "ONE SPARK",
    artist: "TWICE",
    songType: "single",
    url: "https://open.spotify.com/track/7cIn67LEvk16v6komC8znS",
  },
  {
    release: "February 23, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/with-youth.png",
    title: "RUSH",
    artist: "TWICE",
    songType: "ep",
    url: "https://open.spotify.com/track/366hct4ncFRf5TOvEjMVuf",
  },
  {
    release: "February 23, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/with-youth.png",
    title: "NEW NEW",
    artist: "TWICE",
    songType: "ep",
    url: "https://open.spotify.com/track/1z2vNmmIFLSw7zfhr2hxWt",
  },
  {
    release: "February 23, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/with-youth.png",
    title: "BLOOM",
    artist: "TWICE",
    songType: "ep",
    url: "https://open.spotify.com/track/4bheT1Drc2vyQgN5VTwr8W",
  },
  {
    release: "February 23, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/with-youth.png",
    title: "YOU GET ME",
    artist: "TWICE",
    songType: "ep",
    url: "https://open.spotify.com/track/366HAwk1KLvWOwf1tml3jA",
  },
  {
    release: "February 20, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/the-winning.png",
    title: "Shopper",
    artist: "IU",
    songType: "ep",
    url: "https://open.spotify.com/track/1c6kkrWnpy68eYDfBdxNtF",
  },
  {
    release: "February 20, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/the-winning.png",
    title: "Holssi",
    artist: "IU",
    songType: "ep",
    url: "https://open.spotify.com/track/0UTtK6hregIBOsefavRI26",
  },
  {
    release: "February 20, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/the-winning.png",
    title: "Shh..",
    artist: "IU",
    songType: "ep",
    url: "https://open.spotify.com/track/20uUaRkfRJZG15mXfn7LaU",
  },
  {
    release: "February 20, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/the-winning.png",
    title: "I stan U",
    artist: "IU",
    songType: "ep",
    url: "https://open.spotify.com/track/0NnXG9qhpf0E6elVQdWLE7",
  },
  {
    release: "February 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/easy.png",
    title: "Good Bones",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/4UXmlYr1AbcsWsIbrUz2DC",
  },
  {
    release: "February 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/easy.png",
    title: "EASY",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/2O4Bb2WCkjlTPO827OnBMI",
  },
  {
    release: "February 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/easy.png",
    title: "Swan Song",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/2GquhrcHbl2zOnF5javAFp",
  },
  {
    release: "February 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/easy.png",
    title: "Smart",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/4lR8sYGMGZPvthF2yUfo7T",
  },
  {
    release: "February 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/easy.png",
    title: "We got so much",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/5fCKBIJ7BwaCpxxwZCbS5X",
  },
  {
    release: "February 13, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/bam-yang-gang.png",
    title: "Bam Yang Gang",
    artist: "BIBI",
    songType: "single",
    url: "https://open.spotify.com/track/5juCu4WFTFRZ2XilopAMTy",
  },
  {
    release: "February 2, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/i-got-you.png",
    title: "I GOT YOU",
    artist: "TWICE",
    songType: "single",
    url: "https://open.spotify.com/track/35dhwUoJNlxrPyEIJkfDnx",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Super Lady",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/5qI5EUqfDJpQ7w6sMECK7U",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Revenge",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/3qWCIDzq2fBeCMNOL27XLX",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Doll",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4C7PyWUlTLUUgVZQVboCma",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Vision",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/7Dc5JF6aM3FjRMemwC39Ho",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "7Days",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1U7dCgahLpmAqLQ8YLh7tP",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Fate",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/2vNPGH1x5ZwxTjlvzLCyc2",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Rollie",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/71E2JcSbv1abMaua23RBSV",
  },
  {
    release: "January 29, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Wife",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1j8jqwFpFQ8YqsIJAiYFLZ",
  },
  {
    release: "January 24, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/2.png",
    title: "Love wins all",
    artist: "IU",
    songType: "single",
    url: "https://open.spotify.com/track/0djkJ3iAARXRCbfbwwVc3o",
  },
  {
    release: "January 19, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/all-night.png",
    title: "All Night",
    artist: "IVE",
    songType: "single",
    url: "https://open.spotify.com/track/1hkeifGMiDQjXlvAsIoDaa",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "DASH",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/2RoYgkPzUY0vY7lhUuyus1",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "Soñar (Breaker)",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/6UwrPxRaR5HPNLDDl7RcT9",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "Run For Roses",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/4byr9TsXs4qtm8rG2FfwRW",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "BOOM",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/4UEXKi06Ykkx52mme7VvoH",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "Passionfruit",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/773OzGjcoYdvfbRqpympVW",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "XOXO",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/5jJgfoe8qJ59Dtp5nWmVVX",
  },
  {
    release: "January 15, 2024",
    year: "2024",
    heart: <LuHeart />,
    img: "./images/fe3o4-break.png",
    title: "Break The Wall",
    artist: "NMIXX",
    songType: "ep",
    url: "https://open.spotify.com/track/1SmJafjGG3oM3sflmcZRXU",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "To. X",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/2gyCwrOcC6JBoaJ8JGJ7T8",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "Melt Away",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/2cZtazNq0IRRFymK7UaRa0",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "Burn It Down",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/1y8tPIOh9kR3eQE6TeBCwe",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "Nightmare",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/3dmZOzXDFXEZXdjPqJJPKt",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "All For Nothing",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/6kniGjw06j9O7GFgEFwu8v",
  },
  {
    release: "November 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/to-x.png",
    title: "Fabulous",
    artist: "TAEYEON",
    songType: "ep",
    url: "https://open.spotify.com/track/4vPyZrbv6WnOx4P91rbatz",
  },
  {
    release: "October 27, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/perfect-night.png",
    title: "Perfect Night",
    artist: "LE SSERAFIM",
    songType: "single",
    url: "https://open.spotify.com/track/74X2u8JMVooG2QbjRxXwR8",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "Off The Record",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/6TNx6kHZeVDByUNMVxkAfa",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "Baddie",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/7uyeEbG6hyApgXuEypGcsZ",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "Either Way",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/5c1EubDxHdulbausF5CpX5",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "Holy Moly",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/5q288Nbf39kqh2HtI2H2op",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "OTT",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/0ANTnEM0En14CMHPxs0MZj",
  },
  {
    release: "October 13, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-mine.png",
    title: "Payback",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/1RYK0mKtwjWaNLe7Mi6jYN",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "Rainy Days",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/54bg1e6ABcZfpU3yzwxnPf",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "Blue",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/2UU11hvjN1JIn4iihEodNT",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "Love Me Again",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/0SftJDguUa1F5SsQwwkLw4",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "Slow Dancing",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/5h1BN75CEh8wdSwE1xrbSe",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "For Us",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/4HAOgAnILvXCbSODMoRnmD",
  },
  {
    release: "September 8, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/layover.png",
    title: "Slow Dancing (Piano Ver.)",
    artist: "V",
    songType: "ep",
    url: "https://open.spotify.com/track/7pgbDdy7ax962o9d2xJceV",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "New Jeans",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/7woEDtme8YkFiWeyiinIjy",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "Super Shy",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/0kwrPQkiGVE8KTHalH1uMo",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "ETA",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/56v8WEnGzLByGsDAXDiv4d",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "Cool With You",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/02wk5BttM0QL38ERjLPQJB",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "Get Up",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/1wUnuiXMMvhudmzvcCtlZP",
  },
  {
    release: "July 21, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/get-up.png",
    title: "ASAP",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/5fpyAakgFOm4YTXkgfPzvV",
  },
  {
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "Queencard",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4uOBL4DDWWVx4RhYKlPbPC",
  },
  {
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "Allergy",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/38MKW2tQHtyO8djIOKlEFF",
  },
  {
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "Lucid",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4fg42mtrSFuKQ9NYBboiiN",
  },{
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "All Night",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1abAIeSQCbdPcxWgiwDOmL",
  },
  {
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "Paradise",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/0M0LPSeg23xSAELGs2TbXf",
  },
  {
    release: "May 15, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/i-feel.png",
    title: "Peter Pan",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4QbdGSGyECE7IRtjolOkjO",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Blue Blood",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/2avdbiswb0d5AFmyyz68xP",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "I AM",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/70t7Q6AYG6ZgTYmJWcnkUM",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Kitsch",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/7foeH2Emgq8A3LWk3q6dat",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Lips",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/0dRSOmb7pqkkmjXCu5BYbe",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Heroine",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/171vXOYrexGMVNEMA5rs00",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Mine",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/2wsRZURBbDbaQUuVT9piu1",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Hypnosis",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/1tzeAVyGwvoHcVzDit0UeT",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "NOT YOUR GIRL",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/05aq7OhxdoLiUKOigmiqcj",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Next Page",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/5vYsQareJoW2jRJjiTFo6K",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Cherish",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/3cw6T3OEgqLiqEDLDQPSnE",
  },
  {
    release: "April 10, 2023",
    year: "2023",
    heart: <LuHeart />,
    img: "./images/ive-ive.png",
    title: "Shine With Me",
    artist: "IVE",
    songType: "ep",
    url: "https://open.spotify.com/track/3L7pilDxJhZz1fP6t4D9P9",
  },
  {
    release: "October 17, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/antifragile.png",
    title: "The Hydra",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/0JosgxxZKZ87QbW5TISJDE",
  },
  {
    release: "October 17, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/antifragile.png",
    title: "ANTIFRAGILE",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/4fsQ0K37TOXa3hEQfjEic1",
  },
  {
    release: "October 17, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/antifragile.png",
    title: "Impurities",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/7F0MuIk5glqtowCUjbn9es",
  },
  {
    release: "October 17, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/antifragile.png",
    title: "No Celestial",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/21ApmVGIzIAIDSBdHu6SVt",
  },
  {
    release: "October 17, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/antifragile.png",
    title: "Good Parts (when the quality is bad but I am)",
    artist: "LE SSERAFIM",
    songType: "ep",
    url: "https://open.spotify.com/track/1sZBzYhrQG40zcSuKkI93c",
  },
  {
    release: "August 22, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/after-like.png",
    title: "After LIKE",
    artist: "IVE",
    songType: "single",
    url: "https://open.spotify.com/track/2gYj9lubBorOPIVWsTXugG",
  },
  {
    release: "August 1, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/new-jeans.png",
    title: "Attention",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/2pIUpMhHL6L9Z5lnKxJJr9",
  },
  {
    release: "August 1, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/new-jeans.png",
    title: "Hype Boy",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/0a4MMyCrzT0En247IhqZbD",
  },
  {
    release: "August 1, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/new-jeans.png",
    title: "Cookie",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/2DwUdMJ5uxv20EhAildreg",
  },
  {
    release: "August 1, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/new-jeans.png",
    title: "Hurt",
    artist: "NewJeans",
    songType: "ep",
    url: "https://open.spotify.com/track/5expoVGQPvXuwBBFuNGqBd",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "TOMBOY",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/0IGUXY4JbK18bu9oD4mPIm",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "Never Stop Me",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/0ckILmtBH2r5UFOtTf2cN0",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "VILLAIN DIES",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/6adPuBjUw3Zh6wK27d8Rgv",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "ALREADY",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1hQtfLmNABXQMSjjYRXqAX",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "POLAROID",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1XCoTc12Trl56sgCPP4R8M",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "ESCAPE",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4O7tVdjaOQARI1rS6E6CCx",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "LIAR",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/4NrmxVJURTgzMH0QKyYy1a",
  },
  {
    release: "March 14, 2022",
    year: "2022",
    heart: <LuHeart />,
    img: "./images/i-never-die.png",
    title: "MY BAG",
    artist: "(G)I-DLE",
    songType: "ep",
    url: "https://open.spotify.com/track/1t8sqIScEIP0B4bQzBuI2P",
  },
]

export default data;